import { render, staticRenderFns } from "./BackupListPage.vue?vue&type=template&id=c53640c6&"
import script from "./BackupListPage.vue?vue&type=script&lang=js&"
export * from "./BackupListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports